export const EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME = 'labels'
